<!-- @format -->

<ng-container *transloco="let t">
  @if (enrolment.state === "NOT_ENROLLED") {
    <sis-contextual-notification variant="warning">{{ t("ENROLMENTS.BASIC_INFO.ENROLMENT_MISSING") }}</sis-contextual-notification>
  }
  @if (this.personCalculationConfig | async; as calculationConfigForPerson) {
    @if (
      (enrolment.state === "REJECTED" || enrolment.processingState === "CURRENTLY_NOT_SELECTED") &&
      noFalseRequirements(calculationConfigForPerson.requirementRules)
    ) {
      <div class="top-spacing">
        <sis-icon [icon]="'fail'" [color]="'danger'"> </sis-icon>
        {{ t("ENROLMENTS.BASIC_INFO.NOT_SELECTED_NO_AVAILABLE_SEATS") }}
      </div>
    }
  }
  @if (enrolmentCalculationConfig$ | async; as enrolmentCalculationConfig) {
    <div class="top-spacing">
      <sis-course-unit-realisation-seats [enrolmentCalculationConfig]="enrolmentCalculationConfig"></sis-course-unit-realisation-seats>
    </div>
  }
  @if (enrolment.studyRightId) {
    <sis-description-list [columnCount]="1">
      <dl>
        <ng-template #listItem>
          <dt>{{ t("ENROLMENTS.BASIC_INFO.STUDY_RIGHT") }}</dt>
          <dd>{{ enrolment.studyRightId | studyRightName | async | localizedString }}</dd>
        </ng-template>
      </dl>
    </sis-description-list>
  }
  @if (enrolment.state !== "NOT_ENROLLED") {
    <app-enrolment-requirement-rules [enrolment]="this.enrolment"></app-enrolment-requirement-rules>
  }
  @if (enrolmentCalculationConfig$ | async; as enrolmentCalculationConfig) {
    <div>
      @if (enrolmentCalculationConfig?.orderingPersonRules?.length > 0) {
        <a
          fudisLink
          href="/student/courseunit/{{ enrolment.courseUnitId }}/completion-methods?courseUnitRealisation={{
            enrolment.courseUnitRealisationId
          }}&tabId=1"
          [external]="true"
          [title]="'ENROLMENTS.ENROLMENT_MODAL.SORTING_RULES_LINK' | translate"></a>
      }
    </div>
  }
  @if (courseUnitRealisation$ | async; as courseUnitRealisation) {
    <div>
      @if (courseUnitRealisation?.learningEnvironments?.length > 0) {
        <a
          fudisLink
          href="/student/courseunit/{{ enrolment.courseUnitId }}/completion-methods?courseUnitRealisation={{
            enrolment.courseUnitRealisationId
          }}&tabId=0"
          [external]="true"
          [title]="'ENROLMENTS.ENROLMENT_MODAL.LEARNING_ENVIRONMENTS_LINK' | translate"></a>
      }
    </div>
    <div>
      @if (isCrossStudy(courseUnitRealisation)) {
        <a
          fudisLink
          [href]="'/student/ripa-enrolment-information'"
          [external]="true"
          [title]="'ENROLMENTS.ENROLMENT_MODAL.CROSS_STUDY.CONSENT_LINK' | translate"></a>
      }
    </div>
  }
</ng-container>
